//translation
import { tl } from "framework/utils/Translator";
import Cookies from "js-cookie";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import LocalShippingIcon from "@material-ui/icons/LocalShippingOutlined";

//framework modules
import DashboardActivity from "framework/modules/Dashboard/DashboardActivity";
import OrderTrackingActivity from "framework/modules/OrderTracking/OrderTrackingActivity";

//auth
import Login from "framework/pages/Login";
import ChangePasswordActivity from "framework/pages/ChangePasswordActivity";
import PasswordRecovery from "framework/pages/PasswordRecovery";
import PasswordReset from "framework/pages/PasswordReset";
import ProfilePageActivity from "framework/pages/ProfilePageActivity";

var dashRoutes = [
  {
    collapse: true,
    invisible: true,
    name: "Pages",
    icon: DashboardIcon,
    state: "authCollapse",
    views: [
      {
        path: "/login",
        name: "Asteris Digital Lab",
        component: Login,
        layout: "/auth",
      },
      {
        path: "/recovery",
        name: "Forget Password",
        invisible: true,
        icon: DashboardIcon,
        component: PasswordRecovery,
        layout: "/auth",
      },
      {
        path: "/reset",
        name: "Reset Password",
        invisible: true,
        icon: DashboardIcon,
        component: PasswordReset,
        layout: "/auth",
      },
      {
        path: "/change-password",
        name: "Change Password",
        invisible: true,
        icon: DashboardIcon,
        component: ChangePasswordActivity,
        layout: "/admin",
      },
      {
        path: "/profile",
        name: "Profile",
        invisible: true,
        icon: DashboardIcon,
        component: ProfilePageActivity,
        layout: "/admin",
      },
    ],
  },
  ...[
    {
      path: "/dashboard",
      name: tl(Cookies.get("lang"), "Dashboard"),
      menu: "ACCT",
      icon: DashboardIcon,
      state: "DASH",
      component: DashboardActivity,
      layout: "/admin",
    },
    {
      path: "/order-tracking",
      name: tl(Cookies.get("lang"), "orderTracking"),
      menu: "TRACK",
      icon: LocalShippingIcon,
      state: "orderTracking",
      component: OrderTrackingActivity,
      layout: "/admin",
    },
  ],
];

//for Saas route configuration, see admin component file on render method to change modules

export default dashRoutes;
